import * as ShopService from '../../service/ShopService'
import  * as types from '../mutation-types'
const state = {
	addressList:[],
	pageNo:1,
	shopList:[],
	postageList:[],
	selectedAddress:{},
	cartCount: 0,
	managementColumnList: [],
	subjectList: [],
  goodsInfo: {},
}
const getters = {
	addressList:()=>state.addressList,
	postageList:()=>state.postageList,
	shopList:()=>state.shopList,
	selectedAddress:()=>state.selectedAddress,
	cartCount: () => state.cartCount,
	managementColumnList: state => state.managementColumnList,
	subjectList: state => state.subjectList,
  goodsInfo: state => state.goodsInfo,
}
const mutations = {
	// -------------------------- 商品信息 --------------------------
	[types.GOODS_INFO](state, res) {
		state.goodsInfo = {...state.goodsInfo, ...res}
	},
	// -------------------------- 商品信息 end --------------------------
		[types.GET_POSTAGE_LIST](state,res){
			state.postageList = res
		},
		[types.GET_ADDRESS_LIST](state,res){
			let defaultList = res.map((item,index)=>{
				if(item.isDefault||index===0){
					state.selectedAddress = item
				}
				item.isDefault = Boolean(item.isDefault)
				return item
			})
			state.addressList = defaultList
		},
		[types.UPDATE_ADDRESS_LIST](state,newItem){
			let newList = []
			if(newItem.isDefault==1){
				newList = state.addressList.map((item,index)=>{
					item.isDefault = false
					return item
				})
			}
			newList = state.addressList.map((item,index)=>{
				if(item.id===newItem.id){
					item = newItem
				}
				if(item.isDefault||index===0){
					state.selectedAddress = item
				}
				return item
			})
			state.addressList = newList
		},
		[types.DETELE_ADDRESS](state,addressId){
			let newList = state.addressList.filter(item=>item.id!==addressId)
			if(state.selectedAddress.id === addressId)state.selectedAddress = {}
			state.addressList = newList
		},
		[types.ADD_ADDRESS](state,address){
			if(address.isDefault){
				state.addressList = state.addressList.map(item=>{
					item.isDefault = 0
					return item
				})
			}
			state.addressList = [...state.addressList,address]
		},
		[types.SET_DEFAULT_ADDRESS](state,addressId){
			let newList = state.addressList.map(item=>{
				if(item.id == addressId){
					item.isDefault = true
					state.selectedAddress = item
				}else{
					item.isDefault = false
				}
				return item
			})
			state.addressList = newList
		},
		[types.SELECT_ADDRESS](state,addressId){
			let selectItem = {}
			let newList = state.addressList.map(item=>{
				if(item.id == addressId){
					selectItem = item
				}
				return item
			})
			state.selectedAddress = selectItem
		},
		[types.SET_SELECT_ADDRESS](state,item){
			state.selectedAddress = item
		},
		[types.GET_SHOP_PRODUCT_LIST](state,{pageNo,list}){
			if(pageNo===1){
				state.shopList = [...list]
			}else{
				state.shopList = [...state.shopList,...list]
			}
			state.pageNo = ++pageNo
		},
		[types.GET_CART_COUNT](state,{count}){
			state.cartCount = count
		},
		[types.MANAGEMENT_COLUMN_LIST](state, data) {
			state.managementColumnList = data;
		},
		[types.SUBJECT_LIST](state, data) {
			state.subjectList = data;
		}
}

const actions = {
	// -------------------------------- 商品信息 -------------------------------
	setGoodsInfo({ commit }, data) {
		commit(types.GOODS_INFO,data)
	},
	// -------------------------------- 商品信息 end -------------------------------
	getPostageList({commit,state}){
		return ShopService.getProvincePostage()
			.then(res=>{
				commit(types.GET_POSTAGE_LIST,res.data)
			},rea=>{
				return Promise.reject(rea)
			})
	},
	getAddressList({commit,state}){
		commit(types.REQUEST_DOING)
	 	return ShopService.getAddressList()
			.then(res=>{
				commit(types.REQUEST_CLOSE)
				commit(types.GET_ADDRESS_LIST,res.data)
				return Promise.resolve(res.data)
			},rea=>{
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			})
		},
	deleteAddress({commit,state},addressId){
		return ShopService.deleteAddress(addressId)
			.then(res=>{
				commit(types.DETELE_ADDRESS,addressId)
				return res
			},rea=>{
				return Promise.reject(rea)
			})
	},
	updateAddress({commit,state},reqObj){
		return ShopService.updataAddress(reqObj)
			.then(res=>{
				commit(types.UPDATE_ADDRESS_LIST,res.data)
				return res
			},rea=>{
				return Promise.reject(rea)
			})
	},
	addAddress({commit,state},data){
		return ShopService.addAddress(data).then(res=>{
			commit(types.ADD_ADDRESS,res.data)
			if(data.from=='select'){
				commit(types.SET_SELECT_ADDRESS,res.data)
			}
			return res
		},rea=>{
			return Promise.reject(rea)
		})
	},
	initDefaultAddress({commit,state},id){
		return ShopService.setDefaultAddress(id).then(res=>{
			commit(types.SET_DEFAULT_ADDRESS,id)
			return Promise.resolve(res)
		},rea=>{
			return Promise.reject(rea)
		})
	},
	selectAddress({commit,state},addressId){
		commit(types.SELECT_ADDRESS,addressId)
	},
	initShopList({commit,state},reqObj){
		return ShopService.getShopList({...reqObj,pageNo:1}).then(res=>{
			commit(types.GET_SHOP_PRODUCT_LIST,{pageNo:1,list:res.data})
			return Promise.resolve(res.data)
		},rea=>{
			return Promise.reject(rea)
		})
	},
	getShopList({commit,state},reqObj){
		return ShopService.getShopList({...reqObj,pageNo:state.pageNo}).then(res=>{
			commit(types.GET_SHOP_PRODUCT_LIST,{pageNo:state.pageNo,list:res.data})
			return Promise.resolve(res.data)
		},rea=>{
			return Promise.reject(rea)
		})
	},
	getCartCount({commit,state}){
		return ShopService.cartCount().then(res=>{
			commit(types.GET_CART_COUNT,{count:res.data})
			return Promise.resolve(res.data)
		},rea=>{
			return Promise.reject(rea)
		})
	},
	getManagementColumnList({ commit }, reqObj) {
		return ShopService.getManagementColumnList().then(res => {
			commit(types.MANAGEMENT_COLUMN_LIST, res.data || []);
			return Promise.resolve(res);
		}, rea => {
				return Promise.reject(rea);
		})
	},
	getSubjectList({ commit }, reqObj) {
		return ShopService.getSubjectList(reqObj).then(res => {
			commit(types.SUBJECT_LIST, res.data || []);
			return Promise.resolve(res);
		}, rea => {
			return Promise.reject(rea);
		})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
